import { useMemo } from 'react';

import qs from 'qs';

import { useGlobalFilterDataStore } from 'store/globalFilterData.store';

import { filterValueResolverByKey } from 'components/common/GlobalFiltersInPage/globalFiltersInPage.utils';

export const useGetPageFiltersValue = ({ defaultValues }) => {
    const queryParamsByKey = useMemo(() => {
        const queries = new URLSearchParams(location.search);
        const queryKeysToQueryValueMap: Record<string, string> = {};
        queries.forEach((value, key) => (queryKeysToQueryValueMap[key] = value));
        return queryKeysToQueryValueMap;
    }, [location.search]);

    const { getValueFromStore } = useGlobalFilterDataStore();

    return useMemo(() => {
        let resolvedFilterValues: Record<string, any> = {};

        Object.keys(defaultValues).forEach((filterKey) => {
            const queryParams = qs.parse(queryParamsByKey);
            const queryValue = queryParams[filterKey];
            const storeValue = getValueFromStore<string>(filterKey);

            if (!filterValueResolverByKey[filterKey]) {
                resolvedFilterValues[filterKey] = queryValue || storeValue || defaultValues[filterKey];
            } else {
                resolvedFilterValues[filterKey] = filterValueResolverByKey[filterKey](
                    defaultValues[filterKey],
                    queryValue,
                    storeValue,
                );
            }
        });

        return resolvedFilterValues;
    }, [defaultValues, getValueFromStore, queryParamsByKey]);
};
